import { computed, watch } from 'vue';
import { useProfileStore } from '@/shared/stores/profile';

export function useTheme() {
  const profileStore = useProfileStore();

  const theme = computed({
    get: () => profileStore.theme,
    set: (value: 'light' | 'dark' | 'system') => profileStore.setTheme(value)
  });

  const isDarkMode = computed(() => {
    if (theme.value === 'system') {
      return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
    }
    return theme.value === 'dark';
  });

  function applyTheme() {
    const root = document.documentElement;
    const body = document.body;
    if (isDarkMode.value) {
      root.classList.add('is-dark-mode');
      body.classList.add('is-dark-mode');
    } else {
      root.classList.remove('is-dark-mode');
      body.classList.remove('is-dark-mode');
    }
  }

  // Watch for system theme changes
  if (window.matchMedia) {
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
      if (theme.value === 'system') applyTheme();
    });
  }

  // Watch for theme changes
  watch(isDarkMode, () => applyTheme(), { immediate: true });

  return {
    theme,
    isDarkMode,
    applyTheme
  };
}
